import type {
  AuditTrailEntryUnbranded,
  GetAuditTrailEntriesResponse,
} from "@thalamos/vision-common";

const PAGE_SIZE = 200;

/** Fetches one page of an incident's audit trail. */
export type GetAuditTrailPage = (page: {
  limit: number;
  offset: number;
}) => Promise<{ status: number; data: GetAuditTrailEntriesResponse }>;

/** Every entry in an incident's audit trail, fetched page by page. */
export async function fetchEntireAuditTrail(
  getPage: GetAuditTrailPage,
): Promise<AuditTrailEntryUnbranded[]> {
  const entries: AuditTrailEntryUnbranded[] = [];
  for (;;) {
    const response = await getPage({
      limit: PAGE_SIZE,
      offset: entries.length,
    });
    if (response.status !== 200) {
      throw new Error(
        `Failed to fetch audit trail page: ${String(response.status)}`,
      );
    }
    entries.push(...response.data.entries);
    if (
      response.data.entries.length === 0 ||
      entries.length >= response.data.count
    ) {
      return entries;
    }
  }
}
